import { NgClass } from "@angular/common";
import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { UserCollectionAction } from "@apiserver-rest/ponder-data-client-base";
import { formatDate, formatTime } from "@ponder-shared/utils/general";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";
import { environment } from "../../../../../environments/environment";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { Subscription } from "rxjs";
import { UserCollectionActionDateToggledEvent } from "@ponder-core/events/collection.events";

@Component({
    selector: "user-collection-history-row",
    imports: [NgClass],
    templateUrl: "./user-collection-history-row.component.html"
})
export class UserCollectionHistoryRowComponent {
    @ViewChild("versionTooltip") private versionTooltipRef!: ElementRef<HTMLElement>;
    @ViewChild("undoCheckbox") private undoCheckboxRef!: ElementRef<HTMLInputElement>;
    
    @Input({ required: true }) public action!: UserCollectionAction;
    @Input({ required: true }) public prevAction?: UserCollectionAction;

    public actionDate?: string;
    public actionTime!: string;
    public showDateHeader: boolean = false;
    public actionDelta!: number;
    public actionDeltaStr!: string;
    public prevChangeValue!: number;
    public postChangeValue!: number;
    public isChecked: boolean = false;

    public displayDate: boolean = false;

    private dateToggledSub!: Subscription;
    
    constructor(private events: EventBroker) {
        this.dateToggledSub = this.events.collection.toggleUserCollectionActionDateEvent.subscribe({
            next: (event: UserCollectionActionDateToggledEvent) => {
                if (this.undoCheckboxRef && this.actionDate && this.actionDate == event.actionDate && this.isChecked != event.checked) {
                    this.undoCheckboxRef.nativeElement.checked = event.checked;
                    this.onChecked(event.checked);
                }
            }
        });
    }

    public ngOnDestroy(): void {
        this.dateToggledSub.unsubscribe();
    }

    public ngOnInit(): void {
        this.setDateValue();
        
        if (this.action.countDelta) {
            this.actionDelta = this.action.countDelta;
            this.prevChangeValue = this.action.prevCount;
        } else if (this.action.specialCountDelta) {
            this.actionDelta = this.action.specialCountDelta;
            this.prevChangeValue = this.action.prevSpecialCount;
        } else if (this.action.proxyCountDelta) {
            this.actionDelta = this.action.proxyCountDelta;
            this.prevChangeValue = this.action.prevProxyCount;
        }

        this.postChangeValue = this.prevChangeValue + this.actionDelta;
        this.actionDeltaStr = `${(this.actionDelta > 0) ? '+' : ''}${this.actionDelta}`;
    }

    private setDateValue(): void {
        this.actionTime = formatTime(this.action.datetime);
        this.actionDate = formatDate(this.action.datetime);
        this.showDateHeader = !this.prevAction || (this.action.datetime.getDate() != this.prevAction.datetime.getDate());
    }

    public isMobileScreen(): boolean {
        return isMobileScreen();
    }

    public onHoverEnter(): void {
        if (this.versionTooltipRef) {
            this.versionTooltipRef.nativeElement.style.setProperty("background-image", `url("${environment.ponderImageBaseUrl}/card/small/front/${this.action.itemId}.jpg")`);
            this.versionTooltipRef.nativeElement.classList.remove("invisible"); 
        }
    }

    public onHoverExit(): void {
        if (this.versionTooltipRef) {
            this.versionTooltipRef.nativeElement.classList.add("invisible");
        }
    }

    public onChecked(checked: boolean): void {
        if (this.isChecked == checked) {
            return;
        }

        this.isChecked = checked;
        
        this.events.collection.toggledUserCollectionActionEvent.emit({
            action: this.action,
            selected: this.isChecked
        });
    }

    public onDateChecked(checked: boolean): void {
        this.events.collection.toggleUserCollectionActionDateEvent.emit({
            actionDate: this.actionDate!,
            checked: checked
        });
    }
}